<div>
  <div [class.hide]="fileData === null" id="croppieContainer" class="crop-image-container margin-bottom"></div>
  <div *ngIf="fileData" class="get-cropped-image">
    <button type="button" class="btn btn-default" (click)="onGetCroppedImage()">Get Image</button>
  </div>
</div>
